import { typedQueryClient, useTypedQuery } from "hooks";
import { DevicesDashboardQueryKeys } from "modules/DevicesDashboard/queryKeys";
import { DEVICES_STORAGE_KEYS } from "modules/DevicesDashboard/storageKeys";
import { PAGE_SIZE, getPreference, setPreference } from "utils/common";

import type { DevicePayload } from "modules/DevicesDashboard/queryKeys";
import type { AtLeastOne } from "utils/type";

export const DEFAULT_DEVICE_FILTERS: DevicePayload = {
  dealer_ids: [],
  dealer_location_ids: [],
  brands: [],
  models: [],
  os_versions: [],
  search_term: "",
  order_by: null,
  page: 1,
  page_size: PAGE_SIZE.PageSize25
};

const getInitialDeviceFilters = (): DevicePayload => ({
  ...DEFAULT_DEVICE_FILTERS,
  dealer_ids: getPreference(DEVICES_STORAGE_KEYS.DealerPreference, DEFAULT_DEVICE_FILTERS.dealer_ids),
  dealer_location_ids: getPreference(DEVICES_STORAGE_KEYS.LocationPreference, DEFAULT_DEVICE_FILTERS.dealer_location_ids),
  brands: getPreference(DEVICES_STORAGE_KEYS.BrandsPreference, DEFAULT_DEVICE_FILTERS.brands),
  models: getPreference(DEVICES_STORAGE_KEYS.ModelsPreference, DEFAULT_DEVICE_FILTERS.models),
  os_versions: getPreference(DEVICES_STORAGE_KEYS.OsVersionsPreference, DEFAULT_DEVICE_FILTERS.os_versions),
  order_by: getPreference(DEVICES_STORAGE_KEYS.OrderByPreference, DEFAULT_DEVICE_FILTERS.order_by),
  page_size: getPreference(DEVICES_STORAGE_KEYS.PageSizePreference, DEFAULT_DEVICE_FILTERS.page_size)
});

const persistDeviceFilters = (filters: DevicePayload) => {
  setPreference(DEVICES_STORAGE_KEYS.DealerPreference, filters.dealer_ids);
  setPreference(DEVICES_STORAGE_KEYS.LocationPreference, filters.dealer_location_ids);
  setPreference(DEVICES_STORAGE_KEYS.BrandsPreference, filters.brands);
  setPreference(DEVICES_STORAGE_KEYS.ModelsPreference, filters.models);
  setPreference(DEVICES_STORAGE_KEYS.OsVersionsPreference, filters.os_versions);
  setPreference(DEVICES_STORAGE_KEYS.OrderByPreference, filters.order_by);
  setPreference(DEVICES_STORAGE_KEYS.PageSizePreference, filters.page_size);
};

export const useDevicesFilters = () => useTypedQuery({ queryKey: DevicesDashboardQueryKeys.filters, initialData: getInitialDeviceFilters }).data;

export const setDevicesFilters = (filters: AtLeastOne<DevicePayload>) => {
  const previousFilters = typedQueryClient.getQueryData(DevicesDashboardQueryKeys.filters);
  if (!previousFilters) return;

  const newFilters = { ...previousFilters, ...filters };
  persistDeviceFilters(newFilters);

  typedQueryClient.setQueryData(DevicesDashboardQueryKeys.filters, newFilters);
};
